import { getRgba } from 'utils/getColor';

export const transformThemes = (themes) =>
  themes.map((theme) => ({
    gradientOne: getRgba(theme.gradientOne.rgb),
    gradientTwo: getRgba(theme.gradientTwo.rgb),
    gradientThree: getRgba(theme.gradientThree.rgb),
    gradientFour: getRgba(theme.gradientFour.rgb),
    gradientFive: getRgba(theme.gradientFive.rgb),
    background: getRgba(theme.background.rgb),
    backgroundTransparent: `rgba(${theme.background.rgb.r}, ${theme.background.rgb.b}, ${theme.background.rgb.a}, 0)`,
  }));
